import React from "react";
import FacultyProfilePage from "../components/FacultyProfile";
import Navbar from "../components/Navbar";

const YashodharaDalmia = () => {
    return (
        <>
            <Navbar />
            <FacultyProfilePage
                name="Yashodhara Dalmia"
                image="/Faculty-seasons-Cover.jpg"
                profileImage="/Yashodhara-Dalmia-min.jpg"
                bio="Ms Yashodhara Dalmia is an art historian and independent curator based in New Delhi renowned for her several essays, articles and reviews on contemporary Indian art. Her book ‘Amrita Sher-Gil: A Life’ is an internationally acclaimed account of the life of one of India’s first modern artists. ‘The Making of Modern Indian Art: The Progressives’ is regarded as the definitive account of a seminal phase of Indian art history."
            />
        </>
    );
};

export default YashodharaDalmia;